// Localized "AI Overview" labels Google prefixes onto an AI-Overview answer
// (e.g. inside a People-Also-Ask box). Matching is diacritic-insensitive because
// the parser folds diacritics in the stored text (German "Übersicht mit KI" →
// "Ubersicht mit KI", Swedish "AI-översikt" → "AI-oversikt"), so we normalize
// both the answer and the labels before comparing.
export const AI_OVERVIEW_LABELS = [
  // Major global languages
  "AI Overview",                          // English (en) / Italian (it, uses English)
  "Vista creada con IA",                  // Spanish (es)
  "Vista geral de IA",                    // Portuguese (pt - Brazilian & European)
  "Visão geral criada por IA",            // Portuguese (legacy/alt variant)
  "Aperçus IA",                           // French (fr)
  "Übersicht mit KI",                     // German (de)
  "AI-overzicht",                         // Dutch (nl)
  "Обзор от ИИ",                          // Russian (ru)
  // Asian & Pacific languages
  "AI जवाब",                              // Hindi (hi)
  "AI による概要",                         // Japanese (ja)
  "AI 개요",                               // Korean (ko)
  "Ringkasan AI",                         // Indonesian (id)
  "AI 概览",                               // Chinese Simplified (zh-CN)
  "AI 摘要",                               // Chinese Traditional (zh-TW)
  "Ikhtisar AI",                          // Malay (ms)
  "ข้อมูลภาพรวมโดย AI",                    // Thai (th)
  "Thông tin tổng quan do AI tạo",        // Vietnamese (vi)
  "AI کا مجموعی جائزہ",                    // Urdu (ur)
  "AI উত্তর",                              // Bengali (bn) / Cantonese (yue)
  // Middle Eastern & African languages
  "نبذة باستخدام الذكاء الاصطناعي",        // Arabic (ar)
  "AI Bakışı",                            // Turkish (tr)
  "סקירת AI",                             // Hebrew (he)
  "Muhtasari wa AI",                      // Swahili (sw)
  // European & regional languages
  "Огляд від ШІ",                         // Ukrainian (uk)
  "Przeglądy od AI",                      // Polish (pl)
  "Rezumat generat de AI",                // Romanian (ro)
  "Přehled od AI",                        // Czech (cs)
  "AI pregled",                           // Croatian (hr) / Greek (el)
  "AI-oversigt",                          // Danish (da)
  "AI-översikt",                          // Swedish (sv)
  "AI-yhteenveto",                        // Finnish (fi)
  "AI-oversikt",                          // Norwegian (no)
];

export const stripDiacritics = (s) =>
  (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");

// Matches a localized "AI Overview" label at the start of the text.
export const AIO_LABEL_RE = new RegExp(
  "^\\s*(" +
    AI_OVERVIEW_LABELS.map((l) =>
      stripDiacritics(l).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    ).join("|") +
    ")\\s*",
  "i"
);

// True when the text begins with any localized AI-Overview label.
export const isAiOverviewText = (text) => AIO_LABEL_RE.test(stripDiacritics(text));

/**
 * DM-10271: a People-Also-Ask answer's sources. An answer citing several urls lists them in
 * `urls`; a single-source answer is its own source (its url/urlid/markup); no url means none.
 */
export const paaSources = (question) => {
  if (question?.urls?.length) return question.urls;
  return question?.url ? [question] : [];
};
